import { create } from "zustand";

interface AppInitializationState {
  modelsInitialized: boolean;
  teamsInitialized: boolean;
  tokensInitialized: boolean;
  setModelsInitialized: (initialized: boolean) => void;
  setTeamsInitialized: (initialized: boolean) => void;
  setTokensInitialized: (initialized: boolean) => void;
  isAppInitialized: () => boolean;
  reset: () => void;
}

export const useAppInitializationStore = create<AppInitializationState>(
  (set, get) => ({
    modelsInitialized: false,
    teamsInitialized: false,
    tokensInitialized: false,
    setModelsInitialized: (initialized) =>
      set({ modelsInitialized: initialized }),
    setTeamsInitialized: (initialized) =>
      set({ teamsInitialized: initialized }),
    setTokensInitialized: (initialized) =>
      set({ tokensInitialized: initialized }),
    isAppInitialized: () => {
      const { modelsInitialized, teamsInitialized, tokensInitialized } = get();
      return modelsInitialized && teamsInitialized && tokensInitialized;
    },
    reset: () =>
      set({
        modelsInitialized: false,
        teamsInitialized: false,
        tokensInitialized: false,
      }),
  }),
);
